module.exports = __webpack_public_path__ + "static/img/loader-sprite-map.8b41287.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loader/loader-sprite-map.png
// module id = 96
// module chunks = 0